import React from 'react'
import './IconButton.scss'

export default function IconButton(props: {icon: any, title: string, onClick: (() => void)}) {
  return <button className="iconButton" onClick={props.onClick}>
      {props.icon !== undefined ? <img src={props.icon} alt={`${props.title} icon`} /> : null}
      <span>{props.title}</span>
    </button>;
}